import wx from 'weixin-js-sdk';
import {
    getTicket
} from "@/api/homeApi";

export  default {

    created() {

        this.isWx().then(val => {
            if(val == "wx"){
                this.getXxParams().then(params => {
                    //获取js参数
                    wx.config ({
                        debug : false,
                        appId : params.appId,
                        timestamp : params.timestamp,
                        nonceStr : params.nonceStr,
                        signature : params.signature,
                        jsApiList : [
                            // 所有要调用的 API 都要加到这个列表中
                            // 'updateTimelineShareData',
                            // 'updateAppMessageShareData',
                            // 'onMenuShareWeibo',
                            'onMenuShareTimeline',
                            'onMenuShareAppMessage'
                        ]
                    });
                })
            }
        })

    },
    methods: {
        isWx() {
            let ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                return new Promise(resolve => {
                    resolve("wx");
                });
            } else if (ua.match(/QQ/i) == 'qq') {
                return new Promise(resolve => {
                    resolve("qq");
                });
            } else {
                console.log("不在微信里");
                return new Promise(resolve => {
                    resolve("no-wx");
                });
            }
        },
        async getXxParams() {
            let res = await getTicket();
            return res.data;
        },
        // share(imgUrl,linkUrl,desc,title) {
        //
        //     this.isWx().then(val => {
        //         if(val == "wx"){
        //
        //             wx.ready (function () {
        //
        //                 wx.onMenuShareTimeline({
        //                     title: title, // 分享标题
        //                     link: linkUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //                     imgUrl: imgUrl, // 分享图标
        //                     success: function () {
        //                         // 用户点击了分享后执行的回调函数
        //                     }
        //                 })
        //
        //                 wx.onMenuShareAppMessage({
        //                     title: title, // 分享标题
        //                     desc: desc, // 分享描述
        //                     link: linkUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //                     imgUrl: imgUrl, // 分享图标
        //                     type: 'link', // 分享类型,music、video或link，不填默认为link
        //                     dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        //                     success: function () {
        //                         // 用户点击了分享后执行的回调函数
        //                     }
        //                 })
        //
        //
        //
        //                 // 微信分享的数据
        //                 // let shareData = {
        //                 //     "imgUrl" : imgUrl,
        //                 //     "link" : linkUrl,
        //                 //     "desc" : desc,
        //                 //     "title" : title,
        //                 //     success : function () {
        //                 //         // 分享成功可以做相应的数据处理
        //                 //     }
        //                 // };
        //                 // //分享微信朋友圈
        //                 // wx.updateTimelineShareData (shareData);
        //                 // //分享给朋友
        //                 // wx.updateAppMessageShareData({
        //                 //     title: title, // 分享标题
        //                 //     desc: desc, // 分享描述
        //                 //     link: linkUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //                 //     imgUrl: imgUrl, // 分享图标
        //                 //     success: function () {
        //                 //         // 设置成功
        //                 //     }
        //                 // });
        //
        //
        //                 //分享到微博
        //                 // wx.onMenuShareWeibo (shareData);
        //             });
        //         }
        //     })
        //
        // }

    }


}